import styled from 'styled-components';
import { themeColor } from '@whitelabel/helpers/style/colors';
import { mediaBreakpointUp, marginBottom } from '@whitelabel/helpers/style/grid';
import { get } from '@whitelabel/helpers/style/get';

export const StyledContactForm = styled.div`
  margin-top: 2rem;
`;

export const StyledContactFormInModal = styled.div`
  padding: 1rem;
  ${mediaBreakpointUp('sm')`
    padding: 1.5rem;
  `}

  ${mediaBreakpointUp('lg')`
  padding: 2.5rem;
  `}

  p {
    color: ${themeColor('body')};
    ${marginBottom}
  }

  form > div {
    ${marginBottom}
  }

  button:first-of-type {
    margin-bottom: 1rem;

    ${mediaBreakpointUp('sm')`
      margin-bottom:0;
      margin-inline-end: 2rem;
    `}
  }
`;

export const StyledDivider = styled.hr`
  width: 100%;
  border-top: ${get('borderStyle')};
  background: none;
  ${marginBottom}
`;
